export const snakeCaseToCamelCase = (input: any) => {
  const result = input
    .split('_')
    .reduce(
      (res: any, word: any) =>
        `${res}${word.charAt(0).toUpperCase()}${word
          .substr(1)
          .toLowerCase()}`,
      '',
    );
  return `can${result}`;
};
